<template>
  <div>
    <v-data-table
      :headers="headers"
      fixed-header
      height="40vh"
      :items="attributes"
      class="table"
      hide-default-footer
      mobile-breakpoint="0"
      :items-per-page="attributes.length"
    >
      <template v-slot:[`item.name`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.name || "n/c" }}
        </p>
      </template>
      <template v-slot:[`item.weight`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.weight }}
        </p>
      </template>
      <template v-slot:[`item.isVehicle`]="{ item }">
        <p class="text-sm font-weight-bold mt-4 mb-0">
          {{ item.isVehicle ? "oui" : "non" }}
        </p>
      </template>
      <template v-slot:[`item.mandatory`]="{ item }">
        <v-checkbox
          :input-value="isAttributeSelected('mandatory', item.id)"
          @click="updateAttributeStatus('mandatory', item)"
        ></v-checkbox>
      </template>
      <template v-slot:[`item.rejected`]="{ item }">
        <v-checkbox
          :input-value="isAttributeSelected('rejected', item.id)"
          @click="updateAttributeStatus('rejected', item)"
        ></v-checkbox>
      </template>
      <template v-slot:[`item.included`]="{ item }">
        <v-checkbox
          :input-value="isAttributeSelected('included', item.id)"
          @click="updateAttributeStatus('included', item)"
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "SpotListFormAttributeTable",

  props: {
    attributes: {
      type: Array,
      required: true,
    },

    spotAttributesToUpdate: {
      type: [Object, null],
      default: null,
    },
  },

  data() {
    return {
      headers: [
        {
          text: "Nom",
          value: "name",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Poids",
          value: "weight",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Attribuable à un véhicule",
          value: "isVehicle",
          sortable: true,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Obligatoire",
          value: "mandatory",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Rejeté",
          value: "rejected",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Inclus",
          value: "included",
          sortable: false,
          class: "text-secondary font-weight-bolder opacity-7",
        },
      ],
      attrState: {
        mandatory: [],
        rejected: [],
        included: [],
      },
    };
  },

  created() {
    if (this.spotAttributesToUpdate) {
      this.attrState = this.convertSpotAttributesToUpdate(
        this.spotAttributesToUpdate
      );
    }
  },

  watch: {
    attrState: {
      handler() {
        this.$emit("attrSelected", this.createAttributeStateComplete());
      },
      deep: true,
    },

    spotAttributesToUpdate(nVal) {
      if (this.spotAttributesToUpdate) {
        this.attrState = this.convertSpotAttributesToUpdate(nVal);
      }
    },
  },

  methods: {
    updateAttributeStatus(e, item) {
      Object.keys(this.attrState).forEach((k) => {
        const attrIdx = this.attrState[k].findIndex((elm) => elm === item.id);
        if (attrIdx >= 0) {
          this.attrState[k].splice(attrIdx, 1);
        } else if (e === k) {
          this.attrState[e].push(item.id);
        }
      });
    },

    isAttributeSelected(k, itemId) {
      return this.attrState[k].includes(itemId);
    },

    createAttributeStateComplete() {
      const AttributeStateComplete = {
        mandatoryAttributes: this.attrState.mandatory,
        forbiddenAttributes: this.attrState.rejected,
        attributes: this.attrState.included,
      };
      return AttributeStateComplete;
    },

    /**
     * Take original data as object {mandatoryAttributes: [{name:'toto', id: "abc"}] ...}
     * And convert it to match the component requirements for attrState with only the id
     * Should be use for update spot data
     * attrState: { mandatory: ['abc'], rejected: [], included: []},
     * @param {*} original - { mandatoryAttributes: [{name:'toto', id: "abc"}] ...}
     * @returns {Object} - {mandatory: ['abc'], rejected: [], included: [] }
     */
    convertSpotAttributesToUpdate(original) {
      return {
        mandatory: original.mandatoryAttributes.map((elm) => elm.id),
        rejected: original.forbiddenAttributes.map((elm) => elm.id),
        included: original.attributes.map((elm) => elm.id),
      };
    },
  },
};
</script>

<style scoped></style>
